/*
 * Filename: sfAuthSuccess.tsx
 * Description: component for sf auth success.
 */

import React from 'react';

const jsforce : any = require('jsforce');


function CQSFAuthSuccess() {
    const jsForce: any = jsforce;
    jsForce.browser.init();
    
    return(
      <>
      </>
    );
}


export default CQSFAuthSuccess;
